var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.braintreeDropInWrapperClass},[_c('div',{ref:"containerId"}),(!_vm.hideSubmitButton)?_c('button',{class:_vm.submitButtonClasses,attrs:{"disabled":_vm.isSubmitButtonDisabled},on:{"click":_vm.handleSubmit}},[_vm._v("\n        "+_vm._s(_vm.submitButtonText)+"\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }